import React, { createContext, useContext, useState } from 'react';

const DateFormatContext = createContext();

export const DateFormatProvider = ({ children }) => {
  const [dateFormat, setDateFormat] = useState(localStorage.getItem("date_format") || "DD-MM-YYYY");

  const updateDateFormat = (newFormat) => {
    setDateFormat(newFormat);
    localStorage.setItem("date_format", newFormat);
  };

  return (
    <DateFormatContext.Provider value={{ dateFormat, updateDateFormat }}>
      {children}
    </DateFormatContext.Provider>
  );
};

export const useDateFormat = () => {
  const context = useContext(DateFormatContext);
  if (!context) {
    throw new Error('useDateFormat must be used within a DateFormatProvider');
  }
  return context;
};
